 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		235: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"5dea399","1":"4b3cdec","2":"395add0","3":"40e82b1","4":"a77f42e","5":"9410d8f","6":"a291699","7":"3c58b10","8":"67297fa","9":"79ec6a4","10":"7f1e18a","11":"ae68167","12":"5e0001d","13":"1b06178","14":"9cfb371","15":"9548d7c","16":"2ef224a","17":"0e2e32b","18":"2f8da44","19":"8cee0b7","20":"89b281b","21":"9b8405c","22":"fa14fa5","23":"164bd04","24":"71051ae","25":"f553267","26":"fdff1c3","27":"6e6d4a1","28":"f77b304","29":"a68fb8a","30":"57be078","31":"d65419b","32":"bca4e13","33":"6cbb1b7","34":"b38dc32","35":"49a57a3","36":"3edcb79","37":"ab0292c","38":"154a34f","39":"c201f5f","40":"0919448","41":"9425a7d","42":"0ab76df","43":"cf14a6c","44":"0ecb9c4","45":"22d2ea3","46":"3120926","47":"a061bfb","48":"95ed1a1","49":"56e2de3","50":"92d7b0e","51":"811c625","52":"3b1e15f","53":"18be620","54":"d816aab","55":"eb15978","56":"7d0fe3c","57":"dcb575c","58":"b0b65af","59":"b4d56fa","60":"9bab6bd","61":"35bb756","62":"7957ff7","63":"8871380","64":"8fd4f9f","65":"ec9628e","66":"8ef9074","67":"0358339","68":"e777d6b","69":"f8bd3e9","70":"56ce1eb","71":"1a9410d","72":"5f73efe","73":"ec06fbb","74":"0e84d9b","75":"b1ddfb1","76":"a086c7a","77":"6fa37ad","78":"ae15df8","79":"eed622d","80":"9e4b537","81":"0239fd9","82":"2098866","83":"1f8f4cb","84":"e0da1ac","85":"0acdcba","86":"c44e7a1","87":"77e6e68","88":"20a8688","89":"a11d3a0","90":"5c105fe","91":"4e12153","92":"e21c989","93":"cec8e40","94":"a35354d","95":"c5c4eed","96":"2d41257","97":"f7c02eb","98":"78c1523","99":"e9bd93c","100":"a68c2e9","101":"e93b721","102":"55d3465","103":"97ecda9","104":"c5c2733","105":"f84a664","106":"a9562dc","107":"54d0414","108":"1982768","109":"fb2b579","110":"72c521f","111":"adab902","112":"00e98a5","113":"6c4c46c","114":"9c22313","115":"5d6c504","118":"2411dbe","119":"a4c3202","120":"843ad84","121":"4a0bbc3","122":"fcb1b25","123":"5c25eea","124":"737db75","125":"2d82354","126":"7a9f15a","127":"f40f675","128":"bb26451","129":"a60bfdb","130":"e683d43","131":"b6bd05e","132":"a433a08","133":"34398e3","134":"043b9eb","135":"96fce89","136":"d2eae5d","137":"ec2b05b","138":"a255264","139":"5e12cab","140":"3a0078e","141":"07f14d5","142":"7a6f84a","143":"2b0426e","144":"2047404","145":"3ab6b5b","146":"eeaed82","147":"2d14708","148":"0678db2","149":"8a69fb9","150":"495205d","151":"a88bdb4","152":"cdd3d0c","153":"6e4345e","154":"36c89a0","155":"c939d78","156":"dd242ea","157":"0dbaf42","158":"b3e0e1c","159":"53c899c","160":"ac7c8d5","161":"7c66182","162":"60e12bc","163":"50d480f","164":"eea7d60","165":"4ee6342","166":"da0285b","167":"76edc6b","168":"0388af0","169":"af23778","170":"bf648c0","171":"6f13d8b","172":"5fcae2c","173":"fd6d88d","174":"c9106a5","175":"d5cc4a5","176":"d6c9b6f","177":"47531f8","178":"ae89a20","179":"5537906","180":"fe3cd1e","181":"33f528c","182":"198515a","183":"70a22c8","184":"cf8e69a","185":"a048fbd","186":"e0a36b5","187":"1f3e955","188":"a5b96f2","189":"6209ece","190":"4d21c05","191":"870cf79","192":"0ff7999","193":"d521ae7","194":"868e29f","195":"1ea7017","196":"ab7bb74","197":"ff27f33","198":"d79a7e9","199":"a444d6a","200":"3b29102","201":"64e7269","202":"20a8bde","203":"019b18d","204":"ca4a9a6","205":"8138ef5","206":"c71299a","207":"db7a406","208":"96e522f","209":"3ed85e1","210":"4db481f","211":"b8d054c","212":"15c7370","213":"905d270","214":"08a3b63","215":"83178a7","216":"0c0e0b7","217":"a7eb23f","218":"accb4fc","219":"64a708b","220":"5e574fb","221":"8c31ccf","222":"7559380","223":"3854241","224":"ce4e6a3","225":"c350f46","226":"0ecc9b8","227":"b150ae4","228":"fe86264","229":"362bbf3","230":"b6725cc","231":"6b3663f","232":"b5e074c","233":"27e3305","234":"0ab55fa","237":"b0b0ff0","238":"5299752","239":"8d71660","240":"3403437","241":"c4be32e","242":"1392bc5","243":"7e192ff","244":"cf3c0a1","245":"f536d44","246":"8ced667","247":"61a289a","248":"94f54ba","249":"f209d63","250":"c049fea","251":"24cf87e","252":"ab0a6bf","253":"b36b68b","254":"716798d","255":"a018d52","256":"77c45ba","257":"265565c","258":"4098df6","259":"f8e67b0","260":"538718d","261":"9c0d8d9","262":"40756f6","263":"c044617","264":"742299c","265":"50a0ef5","266":"023a14b","267":"f3e7c89","268":"02a3f25","269":"0f81e33","270":"39d76a8","271":"1cffa7e","272":"bf308d7","273":"74871fc","274":"4ee253e","275":"33931e6","276":"8879455","277":"fb7bb02","278":"a667e19","279":"f901493","280":"a438138","281":"f11e391","282":"34aece2","283":"3e1f105","284":"3784393","285":"1579d63","286":"1da1da9","287":"8493d2d","288":"edcefb8","289":"392abe7","290":"672747a","291":"ca02421","292":"80a358d","293":"a162a5a","294":"1ddc058","295":"2897e9e","296":"a33694f","297":"1764153","298":"3512505","299":"1291b11","300":"157f108","301":"ec6154a","302":"114a6e9","303":"6cf7137","304":"16a2f47","305":"7147441","306":"2fcc9ae","307":"7aeacf6","308":"26a4321","309":"f0e63de","310":"b79426b","311":"3a8858d","312":"dbb0b5b","313":"e7e251e","314":"f4cf41d","315":"a15f079","316":"7b138a3","317":"0c593ef","318":"1e019d1","319":"d3fa106","320":"50d9e09","321":"3914809","322":"9e36439","323":"9aba692","324":"6f4465f","325":"f99d683","326":"edc66c6","327":"a9b2a6c","328":"443450f","329":"17766b1","330":"387199b","331":"c936608","332":"2850ed7","333":"3ca71f0","334":"34a8b59","335":"a546467","336":"784700e","337":"185a2d1","338":"630ebe2","339":"0871431","340":"a47a174","341":"b6578fd","342":"65197e4","343":"9f795c1","344":"2346c51","345":"275b8fb","346":"18e7ea6","347":"ff19e3d","348":"bedbf0b","349":"9a38cb5","350":"6c239aa","351":"d77ab7c","352":"5c88770","353":"0521f4f","354":"df72a6f","355":"bf63b13","356":"a8fbfaf","357":"1083c6c","358":"4d01e11","359":"b3cbe79","360":"7217f5f","361":"f664c28","362":"5d674c3","363":"44b5f09","364":"21c022b","365":"09d9dd9","366":"98745ff","367":"39faf96","368":"a8455f1","369":"236d342","370":"028e7d6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
